export default "__VITE_ASSET__DS_r_w7x__"